<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { globalInstallationsperiodeHeizungWarmwasserCollection } from '@/models/InstallationsperiodeHeizungWarmwasser';
import type { Ref } from 'vue';

const value: Ref<any> = defineModel();

const perioden = globalInstallationsperiodeHeizungWarmwasserCollection();
</script>
<template>
    <KpSelectField
        :label="$t('installationsperiode')"
        v-model="value"
        :options="perioden.getModels()"
        option-label="periode"
        option-value="id"
    ></KpSelectField>
</template>
